"use client";

import { useEffect } from "react";
import { useHreflang } from "@/i18n/useHreflang";
import { useLanguage } from "@/i18n/LanguageContext";
import HeaderStrip from "./components/HeaderStrip";
import HeroSection from "./components/HeroSection";
import PolicySections from "./components/PolicySections";
import { injectMetaTags } from "@/lib/seoHelpers";

export default function PrivacyPolicyPage() {
  useHreflang();
  const { t, currentLang } = useLanguage();
  const isEs = currentLang === "es";

  useEffect(() => {
    const title = isEs
      ? "Política de Privacidad | Windows and Doors Repair LLC"
      : "Privacy Policy | Windows and Doors Repair LLC";
    const desc = isEs
      ? "Política de privacidad de Windows and Doors Repair LLC. Cómo recopilamos, usamos y protegemos la información de los visitantes."
      : "Privacy policy for Windows and Doors Repair LLC. How we collect, use, and protect information from visitors.";

    document.title = title;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", desc);
    } else {
      const meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      meta.setAttribute("content", desc);
      document.head.appendChild(meta);
    }

    const cleanupSeo = injectMetaTags({
      title,
      description: desc,
      url: isEs
        ? "https://impact-window-repair-miami.com/es/politica-de-privacidad/"
        : "https://impact-window-repair-miami.com/privacy-policy/",
      image: "https://impact-window-repair-miami.com/og/og-default.jpg",
      imageAlt: isEs ? "Política de privacidad Windows and Doors Repair LLC" : "Privacy policy Windows and Doors Repair LLC",
      breadcrumbs: [
        { name: isEs ? "Inicio" : "Home", item: "https://impact-window-repair-miami.com/" },
        { name: isEs ? "Política de Privacidad" : "Privacy Policy", item: "https://impact-window-repair-miami.com/privacy-policy/" }
      ],
      type: "website",
    });

    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: isEs ? "Política de Privacidad" : "Privacy Policy",
      inLanguage: isEs ? "es-US" : "en-US",
      description: desc,
      url: isEs
        ? "https://impact-window-repair-miami.com/es/politica-de-privacidad/"
        : "https://impact-window-repair-miami.com/privacy-policy/",
      publisher: {
        "@type": "Organization",
        name: "Windows and Doors Repair LLC",
        telephone: "+17863774452",
        email: "contact@impact-window-repair-miami.com",
        address: {
          "@type": "PostalAddress",
          streetAddress: "848 Brickell Ave, PH-5",
          addressLocality: "Miami",
          addressRegion: "FL",
          postalCode: "33131",
          addressCountry: "US",
        },
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "privacy-schema";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      cleanupSeo();
      const el = document.getElementById("privacy-schema");
      if (el) document.head.removeChild(el);
    };
  }, [currentLang, isEs, t]);

  return (
    <main className="w-full">
      <HeaderStrip />
      <HeroSection />
      <PolicySections />
    </main>
  );
}